//https://stackoverflow.com/questions/40510611/typescript-interface-require-one-of-two-properties-to-exist/49725198#49725198
import {Letters} from "../state/state";

export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> =
    Pick<T, Exclude<keyof T, Keys>>
    & {
    [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>
}[Keys]

export type RequireOnlyOne<T, Keys extends keyof T = keyof T> =
    Pick<T, Exclude<keyof T, Keys>>
    & {
    [K in Keys]-?:
    Required<Pick<T, K>>
    & Partial<Record<Exclude<Keys, K>, undefined>>
}[Keys]

export const capitalLetterRegex = /[A-Z]/g;
export function phraseUniqueLetterCount(phrase:string):number {
    return phraseUniqueLetters(phrase).length;
}

export function phraseUniqueLetters(phrase:string):string[] {
    const letters:string[] = [];
    for (let i = 0; i < phrase.length; i++) {
        if (Letters.includes(phrase[i]) && !letters.includes(phrase[i])) {
            letters.push(phrase[i]);
        }
    }
    return letters;
}

export const ChatMaxCombineTime = 5000;